export const VERTICALS = [
    { id: 1 ,  name: 'Refinance' },
    { id: 2 ,  name: 'Tax' },
    { id: 3 ,  name: 'Life Insurance' },
    { id: 4 ,  name: 'New Purchase' },
    { id: 5 ,  name: 'Med Sup' },
    { id: 6 ,  name: 'Solar' },
    { id: 7 ,  name: 'Reverse' },
    { id: 8 ,  name: 'Loan Mod' },
    { id: 9 ,  name: 'CreditRepair' },
    { id: 10 , name: 'HomeSecurity' },
    { id: 11 , name: 'Student Loans' },
    { id: 12 , name: 'Personal Loans' },
    { id: 13 , name: 'HealthCare' },
    { id: 14 , name: 'HomeImprovements' },
    { id: 15 , name: 'Personal Loans' },
    { id: 16 , name: 'HomeOwner Insurance' },
    { id: 17 , name: 'Heloc' },
    { id: 18 , name: 'Home Window' },
    { id: 19 , name: 'Refinance Feed' },
    { id: 20 , name: 'Solar Feed' },
    { id: 21 , name: 'Credit' },
    { id: 22 , name: 'Roofing' },
    { id: 23 , name: 'Gutters' },
    { id: 24 , name: 'Personal Loans' },
    { id: 25 , name: 'Home Warranty' },
    { id: 26 , name: 'Bathroom Remodel' },
    { id: 27 , name: 'Welcome' },
    { id: 28 , name: 'Repair Leads' },
    { id: 29 , name: 'Generic Feed Lead' },
    { id: 30 , name: 'Debt Relief' },
    { id: 31 , name: 'HVAC' }
] as const;